module.exports = __webpack_public_path__ + "static/media/Quicksand-Bold.29577832.woff2";